export const base_order_value = 999050;
export const orders_per_day = 288;
export const orders_per_10_min = orders_per_day / (24 * 6);
export const base_date = new Date('2023-02-13T17:50:00.000Z');
export const format_locale_date_ind = 'en-in';

export const getDifferenceDate = (date_future, date_now) => {
  let delta = Math.abs(date_future - date_now) / 1000;

  let days = Math.floor(delta / 86400);
  delta -= days * 86400;

  let hours = Math.floor(delta / 3600) % 24;
  delta -= hours * 3600;

  let minutes = Math.floor(delta / 60) % 60;
  delta -= minutes * 60;
  minutes += hours * 60;

  // let seconds = delta % 60;

  return { days, minutes };
};

export function isInViewport(element) {
  if (!element) return 'NA';
  const rect = element.getBoundingClientRect();
  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.bottom <=
      (window.innerHeight || document.documentElement.clientHeight) &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth)
  );
}

export const convertToLocaleFormat = (number, format) =>
  number.toLocaleString(format);

export const getIndexChangeArr = (num1, num2) => {
  let index_change = [];
  if (num1.length != num2.length) num1.unshift(0);
  for (let i = 0; i < num2.length; i++) {
    if (num1[i] != num2[i]) {
      index_change.push(i);
    }
  }
  return index_change;
};

export const getTotalOrders = (days, minutes) =>
  base_order_value +
  days * orders_per_day +
  parseInt(minutes / 10) * orders_per_10_min;

export const getClosestUpdateTimeInMin = () =>
  3 - (new Date().getMinutes() % 3);

export const liveCountText = 'Baby Bums Safe In Mylo Cloth Diapers';

export const priceTableConstant =
  "<tr> <td> <a target='_blank' href='https://mylofamily.com/product/free-size-reusable-cloth-diaper-with-absorbent-insert-pad-3-36-months-abc-print-pack-of-3-782'>Adjustable Washable & Reusable Cloth Diaper With Absorbent Insert Pad (3M-3Y) | Oeko-Tex Certified | Prevents Rashes - ABC Print - Pack of 3</a> </td> <td> ₹1299 </td> <td> 36% </td></tr>";
